module.exports = __webpack_public_path__ + "img/64.a7abf31d.jpg";